exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".copyFooter[data-v-091411f6]{font-size:12px;margin-top:20px}[data-theme=light] .copyFooter[data-v-091411f6]{color:#757575!important}[data-theme=dark] .copyFooter[data-v-091411f6]{color:#ccc!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-091411f6","scoped":true,"hasInlineConfig":false}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/copyright/copyright.vue
// module id = 311
// module chunks = 0